import { Navigate, useLocation } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
  isAuthenticated: boolean;
  requiresOnboarding?: boolean;
  onboardingCompleted?: boolean;
}

export const ProtectedRoute = ({ 
  children, 
  isAuthenticated, 
  requiresOnboarding = false,
  onboardingCompleted = false 
}: ProtectedRouteProps) => {
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If this is the setup route, allow access regardless of onboarding status
  if (location.pathname === '/setup') {
    return <>{children}</>;
  }

  // For other routes, check onboarding completion
  if (!onboardingCompleted) {
    return <Navigate to="/setup" replace />;
  }

  return <>{children}</>;
};